import { FilterCondition, FilterStructure } from './types'

/**
 * Updates a specific condition within a group in the filter structure.
 * Returns a new filter structure with the updated condition.
 */
export const updateConditionInFilter = (
  filter: FilterStructure,
  groupId: string,
  conditionId: string,
  updateFn: (condition: FilterCondition) => FilterCondition,
): FilterStructure => ({
  ...filter,
  groups: filter.groups.map((g) => {
    if (g.id === groupId) {
      return {
        ...g,
        conditions: g.conditions.map((c) => {
          if (c.id === conditionId) {
            return updateFn(c)
          }
          return c
        }) as FilterCondition[],
      }
    }
    return g
  }),
})
